module.exports = __webpack_public_path__ + "static/media/BarackObama.89bff015.wav";